import React, { useState } from 'react';
import { AddResourceMenu } from './AddResourceMenu';
import { UploadResourcesModal } from './UploadResourcesModal';
import { AddLinkModal } from './AddLinkModal';
import { AddGenericResourceModal } from './AddGenericResourceModal';
import { useLocale } from '../contexts/LocaleContext';

interface ResourceCreateActionsProps {
  projectId: string;
  size?: 'sm' | 'default' | 'lg';
  variant?: 'default' | 'inverse';
  label?: string;
  trigger?: React.ReactElement;
}

export const ResourceCreateActions: React.FC<ResourceCreateActionsProps> = ({
  projectId,
  size = 'sm',
  variant = 'inverse',
  label,
  trigger,
}) => {
  const { t } = useLocale();
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isAddLinkModalOpen, setIsAddLinkModalOpen] = useState(false);
  const [isAddGenericResourceModalOpen, setIsAddGenericResourceModalOpen] = useState(false);

  return (
    <>
      <AddResourceMenu
        size={size}
        variant={variant}
        label={label ?? t('add_another_resource')}
        trigger={trigger}
        onAddText={() => setIsAddGenericResourceModalOpen(true)}
        onAddLink={() => setIsAddLinkModalOpen(true)}
        onAddDocument={() => setIsUploadModalOpen(true)}
      />
      <UploadResourcesModal
        isOpen={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
        projectId={projectId}
      />
      <AddGenericResourceModal
        isOpen={isAddGenericResourceModalOpen}
        onClose={() => setIsAddGenericResourceModalOpen(false)}
        projectId={projectId}
      />
      <AddLinkModal
        isOpen={isAddLinkModalOpen}
        onClose={() => setIsAddLinkModalOpen(false)}
        projectId={projectId}
      />
    </>
  );
};
